<div id="dept-mass-comm" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Mass Communication</h2>
    <p class="inner-lead mt-3">
      The Department of Mass Communication (BAJMC) at Shah Satnam Ji Girls' College, Sirsa trains students in the art of journalism, media production and communication. With a modern media lab, the department produces skilled media professionals equipped for today's digital world.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>BA (Journalism & Mass Communication) — BAJMC (UG) — 3 Years</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
            <th>Designation</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Renu Dara</td><td>M.M.C, M.Phil, B.Ed, MA (Education), B.Sc (Medical)</td><td>HOD</td></tr>
          <tr><td>2</td><td>Ms. Anupama</td><td>MA (Mass Communication)</td><td>Assistant Professor</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>Mental Health Day — Seminar</li>
      <li>Field Visit (Outdoor)</li>
    </ul>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2022–23</h5>
    <ul class="inner-lead">
      <li>Catch the Rain — Seminar and Participation</li>
    </ul>

  </div>
</div>
